<hr class="mt-3" />

<div class="card">
  <!--<suite-custom-code-block-6>-->
  <div class="d-flex row my-3">
    <div class="col-sm d-flex align-items-center">
      <h1 class="content-header-title my-0">{{ '::PaymentHistoryTitle' | abpLocalization }}</h1>
    </div>
  </div>
  <!--</suite-custom-code-block-6>-->
  <div class="card-body">
    <!--<suite-custom-code-block-7>-->
    <!--</suite-custom-code-block-7>-->
    <ngx-datatable
      [count]="service.data().totalCount"
      [list]="list"
      [rows]="service.data().items"
      default
    >
      <!--<suite-custom-code-block-8>-->
      <!--</suite-custom-code-block-8>-->

      <ngx-datatable-column name="{{ '::Invoice' | abpLocalization }}" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.transaction?.invoice }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="{{ '::PaymentFor' | abpLocalization }}" [sortable]="true">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.requestedItem?.itemName }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="{{ '::Amount' | abpLocalization }}" [sortable]="true">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.transaction.amount }} {{ '::SAR' | abpLocalization }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="{{ '::PaymentDate' | abpLocalization }}" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ formatDateTime(row.transaction.paymentDate) }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="{{ '::Status' | abpLocalization }}" [sortable]="false">
        <ng-template class="test-col" let-row="row" ngx-datatable-cell-template>
          <span
            [ngClass]="this.getStatusClass(row.transaction.status)"
            class="requested-item-status-pill"
          >
            {{
              this.getClaimStatusName(row.transaction.status) | abpLocalization
            }}</span
          >
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [maxWidth]="150"
        [name]="'AbpUi::Actions' | abpLocalization"
        [sortable]="false"
        [width]="150"
      >
        <ng-template let-i="rowIndex" let-row="row" ngx-datatable-cell-template>
          <button (click)="downloadInvoce(row)" ngbDropdownItem>
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.167 10.5191H18.277C15.907 10.5191 13.977 8.5891 13.977 6.2191V3.3291C13.977 2.7791 13.527 2.3291 12.977 2.3291H8.73699C5.65699 2.3291 3.16699 4.3291 3.16699 7.8991V16.7591C3.16699 20.3291 5.65699 22.3291 8.73699 22.3291H16.597C19.677 22.3291 22.167 20.3291 22.167 16.7591V11.5191C22.167 10.9691 21.717 10.5191 21.167 10.5191ZM12.947 16.1091L10.947 18.1091C10.877 18.1791 10.787 18.2391 10.697 18.2691C10.607 18.3091 10.517 18.3291 10.417 18.3291C10.317 18.3291 10.227 18.3091 10.137 18.2691C10.057 18.2391 9.97699 18.1791 9.91699 18.1191C9.90699 18.1091 9.89699 18.1091 9.89699 18.0991L7.89699 16.0991C7.60699 15.8091 7.60699 15.3291 7.89699 15.0391C8.18699 14.7491 8.66699 14.7491 8.95699 15.0391L9.66699 15.7691V11.5791C9.66699 11.1691 10.007 10.8291 10.417 10.8291C10.827 10.8291 11.167 11.1691 11.167 11.5791V15.7691L11.887 15.0491C12.177 14.7591 12.657 14.7591 12.947 15.0491C13.237 15.3391 13.237 15.8191 12.947 16.1091Z"
                fill="#8468CA"
              />
              <path
                d="M18.0967 9.13909C19.0467 9.1491 20.3667 9.14909 21.4967 9.14909C22.0667 9.14909 22.3667 8.47909 21.9667 8.07909C20.5267 6.62909 17.9467 4.01909 16.4667 2.53909C16.0567 2.12909 15.3467 2.40909 15.3467 2.97909V6.46909C15.3467 7.92909 16.5867 9.13909 18.0967 9.13909Z"
                fill="#8468CA"
              />
            </svg>
          </button>
        </ng-template>
      </ngx-datatable-column>
      <!--<suite-custom-code-block-9>-->
      <!--</suite-custom-code-block-9>-->
    </ngx-datatable>
    <!--<suite-custom-code-block-10>-->
    <!--</suite-custom-code-block-10>-->
  </div>
</div>